<template>
  <div class="q-pa-md">
    <q-card flat bordered>
      <q-tabs
        v-model="tab"
        dense
        outside-arrows
        mobile-arrows
        :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 '"
        active-color="white"
        :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
        :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
        align="left"
        narrow-indicator
      >
        <template v-for="{ name, label, tooltip } in tabNames" :key="name">
          <q-tab class="text-weight-light" :name="name" :label="label" no-caps>
            <q-tooltip>{{ tooltip }}</q-tooltip>
          </q-tab>
          <q-separator vertical />
        </template>
      </q-tabs>
      <q-separator />

      <q-tab-panels v-model="tab" animated>
        <q-tab-panel
          v-for="{ name, component } in tabNames"
          :key="name"
          :name="name"
          class="q-pa-none"
        >
          <component :is="component" :symbol="symbol" />
        </q-tab-panel>
      </q-tab-panels>
    </q-card>
  </div>
</template>

<script setup>
import { ref, markRaw } from "vue";
import StockWiseBrokerAnalyticsIntraday from "src/components/StockProfile/StockWiseBrokerAnalyticsIntraday.vue";
import StockWiseBrokerAnalyticsPro from "src/components/BrokerComponents/StockWiseBrokerAnalyticsPro.vue";
import StockWiseBrokerAnalytics from "src/components/StockProfile/StockWiseBrokerAnalytics.vue";
import StockProfileBrokerTransaction from "src/components/StockProfile/StockProfileBrokerTransaction.vue";

const props = defineProps({
  symbol: {
    type: String,
  },
});

let tab = ref("broker_analytics");
const tabNames = ref([
  {
    name: "broker_analytics",
    label: "Broker Analytics",
    tooltip: "StockWise Broker Analytics",
    component: markRaw(StockWiseBrokerAnalytics),
  },
  {
    name: "broker_analytics_pro",
    label: "Broker Analytics Pro",
    tooltip: "Broker Pro",
    component: markRaw(StockWiseBrokerAnalyticsPro),
  },
  {
    name: "broker_transaction",
    label: "Broker Transaction",
    tooltip: "StockWise Broker Transaction",
    component: markRaw(StockProfileBrokerTransaction),
  },
  {
    name: "broker_intraday",
    label: "Broker Analytics Intraday",
    tooltip: "StockWise Broker Analytics Intraday",
    component: markRaw(StockWiseBrokerAnalyticsIntraday),
  },
]);
</script>
